import {getBlockStringBefore} from "./getBlockStringBefore.js";
export const getLineStringBefore = (editor) => {
  const blockStringBeforeCursor = getBlockStringBefore(editor);
  const lines = blockStringBeforeCursor.split("\n");
  return lines[lines.length - 1];
};
